import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ModalService } from '../../services/modal.service';
import { showErrorMessage } from '../../utils/utils';
import { PRODUCT_NAME } from '../../utils/env';
import { KeycloakService } from '../../services/keycloak.service';
import { ExportCommandsDialogComponent, ExportCommandsDialogContext } from './export-commands-dialog.component';
import { ExportResultsDialogComponent, ExportResultsDialogContext } from './export-results-dialog.component';
import { ExportSummaryDialogComponent, ExportSummaryDialogContext } from './export-summary-dialog.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'exports-cmp',
  templateUrl: 'exports.html',
  styleUrls: ['exports.scss'],
  providers: [],
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe, TranslateWithPunctuationPipe],
})
export class ExportsComponent {
  productName = PRODUCT_NAME;
  public isAdmin: boolean;

  constructor(private modal: ModalService) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
  }

  download_commands() {
    const context = new ExportCommandsDialogContext();
    context.parent = this;
    this.modal.open(ExportCommandsDialogComponent, context);
  }

  download_results() {
    const context = new ExportResultsDialogContext();
    context.parent = this;
    this.modal.open(ExportResultsDialogComponent, context);
  }

  download_summary() {
    const context = new ExportSummaryDialogContext();
    context.parent = this;
    context.size = 'lg';
    this.modal.open(ExportSummaryDialogComponent, context);
  }

  handleError(error: any, msg: string) {
    if (error && error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à faire cette opération");
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }
}
